module.exports = __webpack_public_path__ + "static/img/jieshao.9c86da10.png";